module.exports = __webpack_public_path__ + "static/media/es.4398afa5.svg";